import React, { FC } from 'react'

import type {
  CoreParkingArea,
  contractParkingSpotsData,
} from '../../../common/validations/contractParkingSpotsSchema'
import {
  QueueEntry,
  useAPIGetParkingQueue,
} from '../../api/apiHooks/useAPIGetParkingQueue'
import { UserMetadata } from '../../../common/validations'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'
import { useAPIGetContractParkingSpotsSuspense } from 'api/apiHooks/useAPIGetContractParkingSpots'
import { useAPIGetUserMetadataSuspense } from 'api/apiHooks/useAPIGetUserMetadata'

export const ParkingSpotsDataLoader: FC<{
  include?: 'all' | 'own'
  children: (data: {
    areas: CoreParkingArea[]
    limitations: contractParkingSpotsData['limitations']
    reservationPossibleUntil: contractParkingSpotsData['reservationPossibleUntil']
    queueItems: QueueEntry[]
    userMetadata: UserMetadata
  }) => React.ReactNode
}> = ({ include = 'all', children }) => {
  const { currentContractId } = useCurrentContract()
  const { data } = useAPIGetContractParkingSpotsSuspense(
    currentContractId,
    include
  )
  const { data: queueItems } = useAPIGetParkingQueue()
  const { data: userMetadata } = useAPIGetUserMetadataSuspense()

  const areas: CoreParkingArea[] = data?.parkingAreas ?? []
  const queue = queueItems ?? []

  return (
    <>
      {children({
        areas,
        limitations: data?.limitations ?? null,
        reservationPossibleUntil: data?.reservationPossibleUntil ?? null,
        queueItems: queue,
        userMetadata,
      })}
    </>
  )
}
